<template>
  <div class="lcu-page">
    <section class="section">
      <Announcement />
      <PageLegend />
    </section>
    <section class="section">
        <div class="row row-large">
            <EnrollmentCart
            :should-setup-stripe="true"
            :user-profile="{
                firstName: user.firstName,
                lastName: user.lastName,
                email: user.email,
            }"
            @set-signup-error="signupError = $event" />
        </div>
        <div class="row row-large" v-show="signupError" id="enroll-error">
          <span class="lcu-enroll-errorMsg lcu-center-text">
            {{ signupError }}
          </span>
        </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import Announcement from 'ç/announcement/Announcement.vue';
import EnrollmentCart from 'ç/enrollment-cart/EnrollmentCart.vue';

export default {
  name: 'enrollment-fallback',
  computed: {
    ...mapGetters(['user']),
  },
  components: {
    PageLegend,
    Announcement,
    EnrollmentCart,
  },
  data() {
    return {
      signupError: false,
    };
  },
};
</script>

<style scoped lang="scss">
.lcu-programInfo-grid {
  display: grid;
  grid-gap: 50px;
  grid-template-columns: 1fr max-content;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 25px;
  }
}

.lcu-programInfo-logo {
  border: 1px solid $page-border;
  border-radius: 5px;
  width: 300px;
}

.lcu-arrow-btn {
  &:after {
    display: inline-block;
    font-family: 'lcu';
    content: '\e80a';
    margin-left: 10px;
  }
}

.lcu-curriculum-list {
  margin: 0;
  padding: 0 17px;
}

.lcu-curriculum-title {
  display: inline-block;
  text-decoration: underline;
  margin-bottom: 10px;
}

.lcu-curriculum-bullet {
  display: block;
  margin-bottom: 5px;

  &:before {
    content: '\2022';
    margin-left: 0;
  }
}

.lcu-curriculum-item {
  margin-bottom: 20px;
}

.lcu-programLoad-error {
  text-align: center;
  font-size: 18px;
}

.lcu-program-brokenImg {
  width: 165px;
}

.lcu-program-registered {
  display: inline-block;
  background-color: #dfeaf6;
  padding: 10px;
  border-radius: 5px;
}

.lcu-registered-link {
  color: inherit;

  &:after {
    font-family: 'lcu';
    content: '\e80a';
  }
}
</style>
